var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Pipeline',{attrs:{"name":_vm.pipelineName,"title":_vm.pipelineTitle,"resTable":_vm.resTable,"filteredResTable":_vm.filteredResTable,"headers":_vm.headers,"pipelineId":_vm.pipelineId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }